import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationDetailsBlConstants {
    static STEP_TITLE = "Details";
    static DESCRIPTION_LABEL = "Description";
    static TYPE_LABEL = "Application type";
    static TRADE_NAME_LABEL = "Trade name under which business to be conducted?";
    static BUSINESS_OWNER_LABEL = "Business owner";
    static REFERENCE_NUMBER_LABEL = "Reference number";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static TYPE_FORM_CONTROL_NAME = "applicationType";
    static TRADE_NAME_CONTROL = "tradeName";
    static BUSINESS_OWNER_CONTROL = "businessOwner";
    static REFERENCE_NUMBER_CONTROL_NAME = "referenceNumber";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        type: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        tradeName: {
            required: `Trade name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        businessOwner: {
            required: `Business owner ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
